import { render } from "./AlarmHistoryView.vue?vue&type=template&id=cdd6db62"
import script from "./AlarmHistoryView.vue?vue&type=script&lang=js"
export * from "./AlarmHistoryView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__